import { env, isE2EURL } from 'core/utils';

export default {
  Cfg: {
    Code: 'STGEZBPLGPVIAB', // licensed code
    Size: 'Small',

    // Copy/Paste settings
    FocusRect: 2,
    SelectingCells: 2,
    SelectingFocus: 1,
    CopyCols: 0,
    ColMoving: 0,
    PasteFocused: 3,
    ExcludeClear: 1,
    // Copy/Paste setting end

    ShowDeleted: 0,
    ConstHeight: 1,
    AutoUpdate: 1,
    PDFFitPage: 1,
    PrintLocation: 4,
    PrintMarginWidth: 5,
    PrintMarginHeight: 5,
    PrintVarHeight: 3,
    PrintPaddingHeightFirst: 90, // PrintPrefix height
    NoPrintTreeLines: 0,
    SaveExpanded: 1,
    PersistentCfg: 2,
    SuppressCfg: env.NODE_ENV !== 'production' ? 1 : 0,
    CSVValueSeparator: ',',
    TestIds: isE2EURL,
  },
  Actions: {
    OnDragPanelMove: 'DragSelected OR DragRow',
    OnCtrlDragRow: 'DragSelected',
    OnDragRow: 'FocusCells',
    OnDel: 'ClearCells',
  },
  Toolbar: {
    Cells60Cfg: 'Columns',
    Cells70Styles: 'Sizes',
  },
  Panel: {
    // PanelCopyMenu:
    //   'CopyRowBelow,CopyRowsBelow@F,CopyTree,CopyRowsTreeBelow@F,CopySelected@S,CopySelectedTree@S,CopySelectedChildEnd,CopySelectedTreeChildEnd,-,AddRowBelow,AddRowsBelow@2,CopyEmptyBelow,CopyRowsEmptyBelow@2,CopySelectedEmpty,-,AddChildEnd,CopySelectedEmptyChildEnd',
  },
  Lang: {
    Format: {
      GroupSeparator: ' ',
    },
    Alert: {
      DelRow: 'Are you sure you want to remove "%d" ?',
    },
    MenuCell: {
      CopySelectedBelow: 'Duplicate %1 selected rows below',
    },
  },
  MenuPrint: {
    Items: 'ColsCaption,Cols,SpaceCaption,RowsCaption,Foot,OptionsCaption,Options,SizeCaption,Size',
    PrintMarginWidth: 0,
    PrintMarginHeight: 0,
    PrintDPI: 0,
    PrintWidth: 0,
    PrintHeight: 0,
    Attribute: 'CanPrint',
    HideUnused: '1',
  },
};
